import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './ct-w4.component.html';
import "./ct-w4.component.less";
import { SignaturePadModal } from '../signature/signature-pad.component';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import moment from 'moment';
import { InfoModal } from '../info-modal/info-modal.component';
import { OwnerPreviewSignatureModal } from '../preview-signature-modal/owner-preview-signature-modal.component';

export const CtW4Component = {
    templateUrl,
    controller: CtW4Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        maritalStatus: "<",
        addlInputs: "<",
        ownerInfo: "<",
        ownerOfficeInfo: "<",
        stateTaxInfo: "<",
        showSignaturePopup: "<",
        close: "&",
        dismiss: "&"
    }
};

function CtW4Controller(onboardingActionPolicy, onboardingDocumentService, $uibModal, $state, $scope, $q, utilityService, employeeService, onboardingDocumentViewService, stateProvinceService, localeService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('2', vm.application) === 'View';

    vm.taxForm;
    vm.withholdingOptions = {
        dataTextField: "WithholdingText",
        dataValueField: "WithholdingCode",
        dataSource: [
            { WithholdingCode: "A", WithholdingText: "A" },
            { WithholdingCode: "B", WithholdingText: "B" },
            { WithholdingCode: "C", WithholdingText: "C" },
            { WithholdingCode: "D", WithholdingText: "D" },
            { WithholdingCode: "E", WithholdingText: "E" },
            { WithholdingCode: "F", WithholdingText: "F" }
        ]
    };
    vm.onPreview = onPreview;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onSubmit = onSubmit;
    vm.cancel = cancel;
    vm.onSign = onSign;
    vm.onDocDownload = onDocDownload;
    vm.onClose = onClose;
    vm.onSave = onSave;
    vm.stateProvinces;
    vm.onChangeDOM = onChangeDOM;
    vm.updateTaxRates = updateTaxRates;
    vm.updateExemptions = updateExemptions;
    vm.enabledExemption = '';
    vm.onShowI9 = onShowI9;
    vm.onShowFederalW4 = onShowFederalW4;
    vm.onRequestReview = onRequestReview;
    vm.onEditClicked = onEditClicked;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    const allowedChars = /^[a-fA-F\s.,'-]*$/;
    vm.state = {
        view: 'W4'
    };
    vm.reqReview = false;
    vm.isSigned = false;
    vm.prefilled = false;
    vm.editable = true;
    vm.disableEmpFields = true;
    vm.isSaved = false;
    vm.savedData = false;
    vm.showSavedNotification = false;
    vm.previewUrl;
    vm.maritalStatusMapping = [
        { id: 4, status: 'S' },
        { id: 5, status: 'MJ' },
        { id: 6, status: 'H' }];

    vm.$onInit = function () {
        console.log(vm.resolve);
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        vm.reqReview = false;
        vm.date = moment(new Date(), 'DD/MM/YYYY').toDate();
        vm.stateProvinces = this.provinces;
        vm.userProfile = this.profile;
        vm.retrieveLocale()
            .then(function (locale) {
                console.log(locale);
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;
            });

        if (vm.savedInputs != null && vm.savedInputs.FirstName != null && !vm.ownerView) {
            console.log(vm.savedInputs);
            vm.savedData = true;
            vm.showSavedNotification = true;
            fillEmployee(vm.savedInputs);
            //default to user profile
            vm.firstName = this.employeeProfile.FirstName;
            vm.middleName = this.employeeProfile.MiddleName;
            vm.lastName = this.employeeProfile.LastName;
            vm.employeeSsn = this.employeeBankInfo.CurrentSSN;
            vm.address = [this.profile.HomeAddress?.StreetLine1, this.profile.HomeAddress?.StreetLine2, this.profile.HomeAddress?.AptNum].filter(s => !!s).join(', '); //this.profile.HomeAddress?.StreetLine1 + " " + this.profile.HomeAddress?.StreetLine2 + " " + this.profile.HomeAddress?.AptNum;
            vm.city = this.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === this.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = this.profile.HomeAddress.PostalCode;

            //var valid = allowedChars.test(vm.withholdingscode);
            //vm.taxForm.withholdingscode.$setValidity("allowed", valid);
        } else if (vm.userInputs != null && vm.userInputs.FirstName != null) {
            if (this.application) {
                vm.editable = !(this.application && this.application.HasSW4Form !== null && this.application.ProvinceW4 !== 'Review' && this.application.ProvinceW4 !== 'Submitted' && this.application.ProvinceW4 !== 'Pending');
            }
            //prefill this.userInputs
            fillEmployee(vm.userInputs);
            //var valid = allowedChars.test(vm.withholdingscode);
            //vm.taxForm.withholdingscode.$setValidity("allowed", valid);
        } else {
            //prefill user info
            vm.firstName = this.employeeProfile.FirstName;
            vm.middleName = this.employeeProfile.MiddleName;
            vm.lastName = this.employeeProfile.LastName;
            vm.employeeSsn = this.employeeBankInfo.CurrentSSN;
            vm.address = [this.profile.HomeAddress?.StreetLine1, this.profile.HomeAddress?.StreetLine2, this.profile.HomeAddress?.AptNum].filter(s => !!s).join(', ');
            vm.city = this.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === this.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = this.profile.HomeAddress.PostalCode;
            //var valid = allowedChars.test(vm.withholdingscode);
            //vm.taxForm.withholdingscode.$setValidity("allowed", valid);
        }
        //fill owner side info
        if (vm.ownerView) {
            if (vm.userInputs != null && vm.userInputs.EmployerBusinessName != null) {
                // Reverse the mapping using assignment
                vm.neworrehired = vm.userInputs.NewHired === 'yes' ? 'true' : 'false';
                vm.employerName = vm.userInputs.EmployerBusinessName;
                vm.employerSsn = vm.userInputs.FederalEmployeeNumber;
                vm.employeraddress = vm.userInputs.Employersbusinessaddress;
                vm.employercity = vm.userInputs.Employercity;
                vm.employerStateName = vm.stateProvinces.find(x => x.StateName === vm.userInputs.Employerstate);
                vm.employerzipCode = vm.userInputs.Employerzip;
                vm.employerContactPerson = vm.userInputs.Contactperson;
                vm.employerTelephoneNumber = vm.userInputs.Telephonenumber;

                // Convert the date back to the original format
                vm.datehire = moment(vm.userInputs.Datehired, 'DD/MM/YYYY').format('MM/DD/YYYY');
            } else {
                vm.datehire = moment(vm.resolve.employeeProfile.IcdOffices[0].HireDate, 'DD/MM/YYYY').toDate();
                vm.employerName = vm.ownerInfo.LegalBusinessName || vm.ownerInfo.ClientName;
                vm.employerSsn = vm.ownerInfo.FEIN;
                if (vm.ownerInfo.ShippingAddress) {
                    vm.employeraddress = [vm.ownerInfo.ShippingAddress.StreetLine1, vm.ownerInfo.ShippingAddress.StreetLine2, vm.ownerInfo.ShippingAddress.AptNum].filter(Boolean).join(', ');
                    vm.employercity = vm.ownerInfo.ShippingAddress.City;
                    vm.employerStateName = vm.stateProvinces.find(x => x.StateProvinceID === vm.ownerInfo.ShippingAddress.StateProvinceID)
                    /*vm.employerStateName = vm.ownerInfo.ShippingAddress.StateName;*/
                    vm.employerzipCode = vm.ownerInfo.ShippingAddress.PostalCode;
                }
                vm.employerContactPerson = vm.ownerInfo.Owner;
                vm.employerTelephoneNumber = vm.ownerOfficeInfo.OfficePhone?.PhoneNumber ?? '';
            }
        }
        if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
            vm.editable = false;
        }

        //if (vm.ownerView && vm.showSignaturePopup) {
        //    return onPreview();
        //}

        vm.editable = resolveEditable();
    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.ProvinceW4;  // ? ProvinceW4

        // ReviewRequired: always directly editable so the employee can fix it
        if (formStatus === 'ReviewRequired') return true;
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        // Submitted or Approved form: locked so the Edit button shows
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            // Active employees: skip edit button, directly editable
            // Pending employees (new hire): start locked so edit button is shown
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }

        return !vm.application.HasSW4Form              // ? HasSW4Form
            || formStatus === 'Pending'
            || formStatus === 'ReviewRequired';
    }

    //function resolveEditable() {
    //    const appStatus = vm.application.ApplicationStatus;
    //    const formStatus = vm.application.ProvinceW4;  // ? ProvinceW4

    //    if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
    //    if (appStatus === 'Pending') return true;

    //    return !vm.application.HasSW4Form              // ? HasSW4Form
    //        || formStatus === 'Pending'
    //        || formStatus === 'Submitted'
    //        || formStatus === 'ReviewRequired';
    //}

    function onEditClicked() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending') {
            vm.firstName = vm.employeeProfile.FirstName;
            vm.middleName = vm.employeeProfile.MiddleName;
            vm.lastName = vm.employeeProfile.LastName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.address = vm.profile.HomeAddress?.StreetLine1;
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        }
    }


    function onChangeDOM() {
        vm.residencedomicileID = (vm.residencedomicile != null) ?
            vm.residencedomicile.StateProvinceID : null
        // Check if the input has a value and remove the class accordingly
        //if (vm.residencedomicileID != null) {
        //    $('#Gender').removeClass('invalid-input');
        //}
        //vm.setDirty('GenderID');

    }

    function fillEmployee(data) {
        vm.firstName = data.FirstName;
        vm.middleName = data.MiddleName;
        vm.lastName = data.LastName;
        vm.employeeSsn = data.SocialSecurityNumber;
        vm.address = data.EmployeeStreetAddress1StreetAddress2;
        vm.city = data.EmployeeCity;
        vm.stateProvince = vm.stateProvinces.find(x => x.Abbr === data.EmployeeState);
        vm.zipCode = data.EmployeeZip;
        vm.withholdingscodeid = data.WithHold;
        vm.withholdingscode = vm.withholdingOptions.dataSource.find(x => x.WithholdingCode === data.WithHold);
        vm.additionalwithholding = data.AdditionalWithholding;
        vm.reducewithholding = data.ReducedWithholding;
        vm.chkMSRRA = data.Checkifyouareclaiming;
        //vm.residencedomicile = data.Residencedomicile;

        vm.residencedomicile = vm.stateProvinces.find(x => x.Abbr === data.Residencedomicile)
        vm.residencedomicileID = vm.residencedomicile?.StateProvinceID ?? null;
        //vm.datehire = moment(data.Datehired, 'DD/MM/YYYY').toDate();
        vm.date = moment(data.Date, 'DD/MM/YYYY').toDate();

        if (data.Signature) {
            vm.signimage = data.Signature;
            vm.isSigned = true;

        }
        vm.prefilled = true;


    }

    ////event to track if user changed any form data
    //$scope.$watch(() => angular.toJson(vm.taxForm), function (newVal, oldVal) {
    //    if (newVal !== oldVal) {
    //        vm.ISPreview = false;
    //    }
    //}, true);

    $scope.$watch('vm.taxForm.$dirty', function (value) {
        // This is how we tell if there are unsaved form changes so we don't navigate away
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    // Kendo drop-down k-ng-model holds the selected state object; mirror its id into the hidden input that carries form validation (user-profile pattern).
    $scope.$watch(function () {
        return vm.employerStateName;
    }, function (v) {
        vm.employerStateNameID = v ? v.StateProvinceID : null;
    });

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID)
            .then(function (translations) {
                return translations;
            });
    }

    function onSign() {
        return $uibModal.open({
            ...SignaturePadModal,
            resolve: {
                title: () => "Changes to Time Entry"
            }
        }).result.then(function (data) {
            vm.signimage = data;
        });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                console.log(vm.employeeBankInfo.CountryID);
                return locales.filter(function (locale) {
                    console.log(vm.employeeBankInfo.CountryID);
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }


    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '2');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );
    }

    function onShowI9() {
        vm.close({ $value: 'ok' });
    }

    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.taxForm.$dirty) {
            /* vm.close({ $value: 'cancel' });*/
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "You have pending changes. Do you want to continue."
                    },
                    state: () => {
                        return "application-status";
                    }
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }

    function onShowFederalW4() {
        if (vm.ownerView) {
            return $state.go('application-status.ownermodal.federalW4');
        }
        //warning for pending changes
        if (vm.taxForm && vm.taxForm.$dirty) {
            return $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "You have pending changes. Do you want to continue."
                    },
                    state: () => {
                        return "onboarding-document.federalW4";
                    }
                },
                size: 'sm',
                backdrop: 'static'
            }).result
        }
        return $state.go('onboarding-document.federalW4');
    }

    //function onShowFederalW4Signature() {
    //    if (vm.ownerView) {
    //        return $state.go('application-status.ownermodal.federalW4');
    //    }
    //    return $state.go('onboarding-document.federalW4Signature');
    //}



    function updateExemptions() {


        if (vm.withholdingscode) {
            vm.withholdingscodeid = vm.withholdingscode.WithholdingCode;
        } else {
            vm.withholdingscodeid = null;
        }
        var valid = allowedChars.test(vm.withholdingscodeid);
        vm.taxForm.withholdingscodeid.$setValidity("allowed", valid);

        vm.setDirty('withholdingscodeid');

    }

    function updateTaxRates(taxrate) {
        if (taxrate === 'true') {

        } else {
            vm.filingStatus = null;
        }
    }

    function onDocDownload(pages) {
        utilityService.showLoading();
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '1', '9', pages).then(function (result) {
            utilityService.hideLoading();
            return result;
        }).then(function () {
            utilityService.hideLoading();
        });

    }

    function onPreview() {

        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            FirstName: vm.firstName,
            MiddleName: vm.middleName?.substring(0, 1),
            LastName: vm.lastName,
            SocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetAddress1StreetAddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.stateProvince.Abbr,
            EmployeeZip: vm.zipCode,
            WithHold: vm.withholdingscode?.WithholdingCode ?? null,
            AdditionalWithHolding: Number(vm.additionalwithholding) || 0,
            ReducedWithholding: Number(vm.reducewithholding) || 0,
            Checkifyouareclaiming: vm.chkMSRRA,
            Residencedomicile: vm.chkMSRRA === 'true' ? vm.residencedomicile.Abbr : '',
            Signature: vm.signimage,
            Date: moment(vm.date, 'DD/MM/YYYY').format('MM/DD/YYYY')
        }
        if (vm.ownerView) {
            //const phone = (vm.employerTelephoneNumber ?? '').replace(/\D/g, '');
            let ownerData = {
                NewHired: vm.neworrehired === 'true' ? 'yes' : 'no',
                EmployerName: vm.employerName,
                FederalEmployeeNumber: vm.employerSsn,
                EmployerBusinessName: vm.employerName,
                Employersbusinessaddress: vm.employeraddress,
                Employercity: vm.employercity,
                Employerstate: vm.employerStateName.StateName,
                Employerzip: vm.employerzipCode,
                Contactperson: vm.employerContactPerson,
                //Tele1: phone?.slice(0, 3) ?? '',
                //Tele2: phone?.slice(3, 6) ?? '',
                //Tele3: phone?.slice(6) ?? '',
                Telephonenumber: vm.employerTelephoneNumber,
                Datehired: moment(vm.datehire, 'DD/MM/YYYY').format('MM/DD/YYYY')
            }
            formData = { ...formData, ...ownerData }
        }
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, 9).then(function (result) {
            utilityService.hideLoading();
            vm.previewUrl = result;
            return $uibModal.open({
                ...OwnerPreviewSignatureModal,
                resolve: {
                    title: () => "California W4",
                    previewUrl: () => {
                        return vm.previewUrl;
                    },
                    allowApprove: () => {
                        return canApproveForm(vm.application, '2');
                    },
                    allowReview: () => {
                        return canApproveForm(vm.application, '2');
                    },
                    allowSign: () => {
                        return false;
                    }, //for pages without signature
                    showSignaturePopup: () => {
                        return vm.showSignaturePopup;
                    }
                }
            }).result
        }).then(function (data) {
            console.log(data);
            if (data === 'terminate' && vm.showSignaturePopup) {
                return vm.close({ $value: 'ok' });
            }
            if (data.success) {
                vm.employerSignimage = data.dataUrl;
                vm.isSigned = true; //employer version
                return onSubmit();
            }
        }).catch((err) => {
            console.log(err);
            utilityService.hideLoading();
        });


    }

    function onPreviewInPage() {

        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            FirstName: vm.firstName,
            MiddleName: vm.middleName?.substring(0, 1),
            LastName: vm.lastName,
            SocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetAddress1StreetAddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.stateProvince.Abbr,
            EmployeeZip: vm.zipCode,
            WithHold: vm.withholdingscode?.WithholdingCode ?? null,
            AdditionalWithHolding: Number(vm.additionalwithholding) || 0,
            ReducedWithholding: Number(vm.reducewithholding) || 0,
            Checkifyouareclaiming: vm.chkMSRRA,
            Residencedomicile: vm.chkMSRRA === 'true' ? vm.residencedomicile.Abbr : '',
            Date: moment(vm.date, 'DD/MM/YYYY').format('MM/DD/YYYY')
        }

        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, 9).then(function (result) {
            utilityService.hideLoading();
            vm.previewUrl = result;
            return $uibModal.open({
                ...PreviewSignatureModal,
                resolve: {
                    title: () => "Connecticut W4",
                    previewUrl: () => {
                        return vm.previewUrl;
                    }
                }
            }).result;
        }).then(function (data) {
            console.log(data);
            vm.signimage = data.dataUrl;
            vm.isSigned = data.dataUrl != null;
            return onSubmit();
        }).catch((err) => {
            console.log(err);
            utilityService.hideLoading();
        });


    }

    function onSave() {
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '2',
            FirstName: vm.firstName,
            MiddleName: vm.middleName?.substring(0, 1),
            LastName: vm.lastName,
            SocialSecurityNumber: vm.employeeSsn,
            EmployeeStreetAddress1StreetAddress2: vm.address,
            EmployeeCity: vm.city,
            EmployeeState: vm.stateProvince.Abbr,
            EmployeeZip: vm.zipCode,
            WithHold: vm.withholdingscode?.WithholdingCode ?? null,
            AdditionalWithHolding: Number(vm.additionalwithholding) || 0,
            ReducedWithholding: Number(vm.reducewithholding) || 0,
            Checkifyouareclaiming: vm.chkMSRRA,
            Residencedomicile: vm.chkMSRRA === 'true' ? vm.residencedomicile.Abbr : '',
            Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY')
        }

        return onboardingDocumentService.save(vm.employee.UserName, formData, '9').then(function () {
            vm.isSaved = true;
            vm.showSavedNotification = true;
            vm.taxForm.$setPristine();
            return utilityService.hideLoading();
        });
    }

    function onApprove() {
        let approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "2");
        const trans = $q.all(approvePromise).then((res) => {
            if (res) {
                vm.onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Approve failed")
        );
    }

    function onSubmit() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return utilityService.hideLoading();
        }
        let updatePromises = [];
        let submitApplicationPromise = $q.defer();
        vm.isDirtyEdit = vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending' && (vm.application.ProvinceW4 === 'Approved' || vm.application.ProvinceW4 === 'Pending');
        if ((vm.taxForm && vm.taxForm.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isDirtyEdit || isPendingResubmit || vm.isSigned || vm.application.ProvinceW4 === 'ReviewRequired') {
            if (!vm.isSigned) {
                utilityService.hideLoading();
                alert("Preview and Signature are required");
            }
            if (!vm.signimage) {
                utilityService.hideLoading();
                alert("Signature is required");
                return;
            }
            let formData = {
                RequestTypeId: '2',
                FirstName: vm.firstName,
                MiddleName: vm.middleName?.substring(0, 1),
                LastName: vm.lastName,
                SocialSecurityNumber: vm.employeeSsn,
                EmployeeStreetAddress1StreetAddress2: vm.address,
                EmployeeCity: vm.city,
                EmployeeState: vm.stateProvince.Abbr,
                EmployeeZip: vm.zipCode,
                WithHold: vm.withholdingscode?.WithholdingCode ?? null,
                AdditionalWithHolding: Number(vm.additionalwithholding) || 0,
                ReducedWithholding: Number(vm.reducewithholding) || 0,
                Checkifyouareclaiming: vm.chkMSRRA,
                Residencedomicile: vm.chkMSRRA === 'true' ? vm.residencedomicile.Abbr : '',
                Signature: vm.signimage,
                Date: moment(vm.date, 'DD/MM/YYYY').format('DD/MM/YYYY')
            }
            if (vm.ownerView) {
                //const phone = (vm.employerTelephoneNumber ?? '').replace(/\D/g, '');
                let ownerData = {
                    NewHired: vm.neworrehired === 'true' ? 'yes' : 'no',
                    EmployerName: vm.employerName,
                    FederalEmployeeNumber: vm.employerSsn,
                    EmployerBusinessName: vm.employerName,
                    Employersbusinessaddress: vm.employeraddress,
                    Employercity: vm.employercity,
                    Employerstate: vm.employerStateName.StateName,
                    Employerzip: vm.employerzipCode,
                    Contactperson: vm.employerContactPerson,
                    Telephonenumber: vm.employerTelephoneNumber,
                    //Tele1: phone?.slice(0, 3) ?? '',
                    //Tele2: phone?.slice(3, 6) ?? '',
                    //Tele3: phone?.slice(6) ?? '',
                    Datehired: moment(vm.datehire, 'DD/MM/YYYY').format('MM/DD/YYYY')
                }
                formData = { ...formData, ...ownerData }
            }
            submitApplicationPromise = onboardingDocumentService.submit(vm.employee.UserName, formData, 9);
            updatePromises.push(submitApplicationPromise);
        }
        if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }

        }

        const trans = $q.all(updatePromises).then((res) => {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        );
    }


    function cancel() {
        //vm.taxForm = {};
        vm.taxForm.$setPristine(true);
        vm.resetRequestType();
    }
}


export const CTW4Modal = {
    component: "apexCTW4Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}

